<template>
    <div class="goods-box my-form">  
        <img v-if="user && user.avatarUrl" :src="user.avatarUrl">
        <img v-else src="@/assets/img/avatar.png">
    
        <div v-if="formData && formData.length" class="custom-form">
            <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false" :scroll-to-error="true" >
                <template v-for="(item, index) in formData" >
                    <!-- 单行文本 -->
                    <div class="cell-box" v-if="item.tagType === 0" :key="'form' + index">
                        <van-field
                            v-model="formModel[index]['model' + index]"
                            :name="item.label"
                            :label="item.label"
                            :required="item.attributes.checkOptions.require"
                            :placeholder="item.attributes.placeholder || 'Please enter the content'"
                            :readonly="item.label === 'E-mail' && user.email ? true :false"
                            :rules="[{required: item.attributes.checkOptions.require, message: 'Error'}]"
                            :ref="['model' + index]"
                        />
                        <template v-if="item.label === 'E-mail' && !user.email"> 
                            <van-field
                                v-model="code"
                                center
                                clearable
                                label="Code"
                                required
                                maxlength="6"
                                placeholder="Please enter the code"
                                :rules="[{ required: true, message: 'Please enter the code' }]"
                                v-if="item.tagType === 0" 
                                :key="'c' + index"
                                >
                                <template #button>
                                    <span class="code" v-if="newTimer">{{ newCount || 0}}s</span>
                                    <span class="sendcode code" v-else @click="getCode(formModel[index]['model' + index])">Get</span>
                                </template>
                            </van-field>
                        </template>
                    </div>
                    <!-- 单行文本 -->
                    <!-- 多行文本输入框 -->
                    <div class="cell-box" v-if="item.tagType === 1" :key="'form' + index">
                        <div class="cell">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <van-field
                                v-model="formModel[index]['model' + index]"
                                rows="4"
                                type="textarea"
                                class="intro_cell"
                                maxlength="500"
                                :name="item.label"
                                :placeholder="item.attributes.placeholder || 'Please enter the content'"
                                :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                                :ref="['model' + index]"
                            />
                        </div>
                     </div>
                    <!-- /多行文本输入框 -->

                    <!-- 数字输入框 -->
                    <div class="cell-box" v-if="item.tagType === 2" :key="'form' + index">
                        <van-field 
                            v-model="formModel[index]['model' + index]"
                            type="digit" 
                            :label="item.label"
                            :placeholder="item.attributes.placeholder || 'Please enter the content'"
                            :ref="['model' + index]"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: 'Error'}]"
                        />
                    </div>
                    <!-- 数字输入框 -->

                    <!-- 下拉选择框 -->
                    <div class="cell-box" v-if="item.tagType === 3" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            :name="item.label"
                            :label="item.label"
                            :value="formModel[index]['model' + index]"
                            :placeholder="item.attributes.placeholder || 'Please select'"
                            @click="formModel[index].isShow = true ; curIndex = index"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                            />
                            <van-popup v-model="formModel[index].isShow" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="item.columns"
                                @confirm="confirm($event,'1')"
                                @cancel="formModel[index].isShow = false"
                                />
                            </van-popup>
                    </div>
                    <!-- 下拉选择框 -->

                    <!-- 单选框 -->
                    <div class="cell-box" v-if="item.tagType === 4" :key="'form' + index">
                        <div class="cell cell-1">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <div class="yd-checkbox_wrap">
                                    <van-radio-group 
                                        v-model="formModel[index]['model' + index]" 
                                    >
                                        <div  v-for="(opt,i) in item.attributes.options" :key="'checkbox' + i + index" class="yd-checkbox-list">
                                            <!-- <template v-if="opt.label !== 'other'"> -->
                                                <van-radio :name="opt.value">{{opt.value}}</van-radio>
                                            <!-- </template> -->
                                        </div>
                                    </van-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- 单选框 -->

                    <!-- 多选框 -->
                    <div class="cell-box" v-if="item.tagType === 5" :key="'form' + index">
                        <div class="cell cell-1">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <div class="yd-checkbox_wrap">
                                    <van-checkbox-group 
                                        v-model="formModel[index]['model' + index]" 
                                    >
                                        <div  v-for="(opt,i) in item.attributes.options" :key="'checkbox' + i + index" class="yd-checkbox-list">
                                            <!-- <template v-if="opt.label !== 'other'"> -->
                                                <van-checkbox :name="opt.value" shape="square">{{opt.value}}</van-checkbox>
                                            <!-- </template> -->
                                        </div>
                                    </van-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <!-- 多选框 -->
                    
                    <!-- 日期框 -->
                    <div class="cell-box" v-if="item.tagType === 6" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            name="datetimePicker"
                            v-model="formModel[index]['model' + index]"
                            :label="item.label"
                            :placeholder="item.attributes.placeholder || 'Please select the date'"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                            @click="formModel[index].isShow = true; curIndex = index"
                            />
                            <van-popup v-model="formModel[index].isShow" position="bottom">
                            <van-datetime-picker
                                type="date"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="confirm($event,'2')"
                                @cancel="formModel[index].isShow = false"
                            />
                            </van-popup>
                    </div>

                    <!-- 日期框 -->

                    <!-- 日期区间 -->
                    <div class="cell-box" v-if="item.tagType === 7" :key="'form' + index">
                        <van-field
                        readonly
                        clickable
                        name="datetimePicker"
                        v-model="formModel[index]['model' + index][0].start"
                        :label="item.childrens[0].label"
                        :placeholder="item.attributes.placeholder || 'Please select the date'"
                        :required="item.attributes.checkOptions.require"
                        :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                        @click="formModel[index].isShow = true; curIndex = index; isStart = true;"
                        />
                        <van-popup v-model="formModel[index].isShow" position="bottom">
                        <van-datetime-picker
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="confirm($event,'3')"
                            @cancel="formModel[index].isShow = false"
                        />
                        </van-popup>
                        <van-field
                        readonly
                        clickable
                        name="datetimePicker"
                        v-model="formModel[index]['model' + index][0].end"
                        :label="item.childrens[1].label"
                        :placeholder="item.attributes.placeholder || 'Please select the date'"
                        :required="item.attributes.checkOptions.require"
                        :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                        @click="formModel[index].isShow = true; curIndex = index; isStart = false;"
                        />
                        <van-popup v-model="formModel[index].isShow" position="bottom">
                        <van-datetime-picker
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="confirm($event,'3')"
                            @cancel="formModel[index].isShow = false"
                        />
                        </van-popup>
                    </div>

                    <!-- 日期区间 -->

                    <!-- 说明文字 -->
                    <p v-if="item.tagType === 10" class="tipInfo" :key="'form' + index">{{item.attributes.value}}</p>
                    <!-- 说明文字 -->
                  
                    <!-- 套件 -->
                        <!-- 城市选择 -->
                    <div class="cell-box" v-if="item.tagType === 11 && item.label === 'Region'" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            name="area"
                            :label="item.label"
                            placeholder="Please select the region"
                            :value="formModel[index]['model' + index]"
                            @click="showArea = true ; curIndex = index"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                            />
                            <van-popup v-model="showArea" position="bottom">
                              <van-picker
                                title="Cuntry"
                                confirm-button-text="confirm"
                                cancel-button-text="cancel"
                                show-toolbar
                                :columns="countryList"
                                @confirm="onCity"
                                @cancel="showArea = false"
                              />
                            <!-- <van-area
                                :value="cityCode"
                                :area-list="areaList"
                                @confirm="onCity($event)"
                                @cancel="showArea = false"
                                /> -->
                            </van-popup>
                        </div>
                        <!-- 城市选择 -->
                         
                        <!-- 感兴趣类别 -->
                        <div class="cell-box" v-if="item.tagType === 11 && item.label === 'Interest'" :key="'form' + index">
                            <van-cell
                                title="Interest"
                                class="cate_cell"
                                is-link
                                @click="regCareShow"
                                v-if="categoryNum!=''"
                                >
                                <p v-if="categoryNum!=''"><span style="margin-right:0.2rem">{{categoryNum}}</span>choosed</p>
                            </van-cell>
                            <van-cell 
                                title="Interest" 
                                class="cate_cell"
                                is-link 
                                value="Please select" 
                                @click="regCareShow"
                                v-if="categoryNum==''" 
                            />
                        </div>

                        <!-- 感兴趣类别 -->
                        
                        <!-- 展馆选择 -->
                        <div class="cell-box" v-if="item.tagType === 11 && item.label === '展馆选择'" :key="'form' + index">
                            <van-field
                                readonly
                                clickable
                                name="area"
                                :label="item.label"
                                placeholder="请选择展馆"
                                :value="formModel[index]['model' + index]"
                                @click="formModel[index].isShow = true ; curIndex = index"
                                :required="item.attributes.checkOptions.require"
                                :rules="[{ required: item.attributes.checkOptions.require, message: 'Error' }]"
                                />
                                <van-popup v-model="formModel[index].isShow" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="hallList"
                                    @cancel="formModel[index].isShow = false"
                                    @confirm="confirmHall"
                                />
                                </van-popup>
                         </div>
                        <!-- 展馆选择 -->


                    <!-- 套件 -->

                </template>

                <!-- <div class="single-checkbox">
                    <van-checkbox v-model="checkbox" shape="square" />
                    <p>我已阅读并同意展商秀</p>
                    <span @click="showFrame=true">《注册服务条款》</span>
                </div> -->
                
                <div class="vant-btn">
                    <van-button round block type="info"  native-type="submit"> Submit </van-button>
                </div>
            </van-form>
           
        </div>

    <!-- 注册条款 -->
    <frame :showFrame="showFrame" @agree="showFrame = false ; checkbox = true"></frame>

    <!-- 类别 -->
    <categoryPop ref="regCare" :cateList="categoryList" :selectList="categoryList1" @closePop="closePop"></categoryPop>

    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import provincial from '@/assets/js/provincial.json';     //省市区json
import categoryPop from '../my-page/my-reg/categoryPop';   // 类别弹框
import frame from '../my-page/my-reg/frame';   // 条款弹框
import { moment } from '../../utils/utils';   // 时间处理
import { parse } from 'graphql';

export default {
    name:'custom-form',
    data(){
        return{
            formData:[], // 表单数据
            formId:'', // 自定义表单的id
            userformData:[], // 用户填写表单数据
            defaultItem: [ ], // 包含默认的手机，姓名，职务，公司,地址
            formModel: [], // 表单双向绑定数组 v-model Value  
            showArea:false,
            areaList:[], // 地区数据
            areavalue:[], // 选中的地区数据
            cityCode:'',  //省市区编号，默认
            curIndex:null,
            showPicker:false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(2050, 10, 1),
            isStart:true, // 日期区间是否为第一个
            countryList:[],
            checkbox:false,
            showFrame:false, //  显示条款
            categoryNum:"",
            categoryList1: [], //感兴趣类型的选中数组
            showCategory:false, // 显示类别
            hallList:[], // 展馆列表
            
            form: {
                name: "", // 姓名
                Phone: "", // 手机号
                phoneText:'',
                company: "", // 公司名
                JobTitle: "", // 职务
                Province: "", // 省份
                City:'', // 城市
                County:'',  // 区县
                category: '',
                introduction:'',
                flagStyle:'',
                Password:'',
                email:''
            },
            //验证码
            code:'',
            count: 0,
            newCount: 0,
            timer: null,
            newTimer: null,
            codeKey:'',
            //验证码
            currentDate:new Date(),
        }
    },
    components:{ frame,categoryPop },
    computed: {
        ...mapGetters({
            user: "getUserInfo",
            categoryList:'getCategory',
            userId:"getUserId",
            exhibitionId:'getExhibitionId',
            regOrigin:"getRegOrigin",
            country:'getCountry',
        }),
        
    },
    created(){
        this.areaList=provincial;
      this.country.forEach(c=>{
        this.countryList.push(c.nameEn)
      })
        this.init();
    },
    methods:{
        ...mapActions({
            getCustomForm:'getCustomForm',
            getHallList:'getHallList',
            addCustomForm:'addCustomForm',
            getUserCustomForm:'getUserCustomForm',
            LinkToRegFinsh:'linkTo/LinkToRegFinsh',
            patchUser:'my/patchUser',
            patchUserCategory:'my/patchUserCategory',
            sendCode:'my/sendCode',
            sendEamilCode: "my/sendEamilCode",
            validateCode:'my/validateCode',
            putPhone:'my/putPhone',
            regUser:'my/regUser',
            addReg: "en/addReg",
        }),
        ...mapMutations({
            setRegOrigin:'setRegOrigin',
        }),
        async init(){
            let exhibitionId = this.$route.params.id;
            this.$store.commit("setExhibitionId",exhibitionId);
            await this.$Myapollo.getExhibitionInfo(this,exhibitionId,this.userId);
            await this.$Myapollo.getCategory(this,this.exhibitionId);
            await this.$Myapollo.getUserInfo(this);
            this.$Myapollo.addExhibitionView();
            let reqBody = {
                where: {Equal: {N: "exhibitionId", V: exhibitionId},
                        Equal_isdeleted: {n: "isDeleted", v: false}
                },
                order: [{N: "showIndex", V: 0}]
            }
            let hallData = await this.getHallList();
            let hall=[]
            if(hallData.length){
                hall=hallData
            }
            // console.log(hall,'sss')
            hall.map(c=>{
                this.hallList.push(c.nameEn)
            })
            let form = await this.getCustomForm({itemId:exhibitionId,formType:'show.form.visitor.reg.en'});
            console.log(form,'----')
            // 判断是否需要加入默认选项 
            this.formId = form.id;
            if(form.items){
              this.formData = [...form.items];
            }else{
              this.formData = []
            }
            this.initFromData();
            // console.log(this.formData,'formData')
            if(this.user&&this.user.userId){
                this.getuserFromData();
            }
        },
        async getuserFromData(){ // 获取用户的表单数据
            let opt = {
                id:this.exhibitionId,
                type:'show.form.visitor.reg.en',
                userId:this.user.userId
            }
            this.userformData =  await this.getUserCustomForm(opt);
            if(!this.userformData) return;
            this.userformData.forEach(c=>{
                this.formModel.map((v,i)=>{
                    if(v.type == c.tagType && v.label == c.label){
                        v['model' + i] = c.value
                    }
                    if(v.type == c.tagType && v.label == c.label && v.type == 5){ // 多选
                        v['model' + i] =JSON.parse(c.value);
                    }
                    if(v.type == c.tagType && v.label == c.label && v.type == 11){ // 感兴趣的类别
                        if(c.value && v.label == '感兴趣的类别'){
                            this.form.category = c.value;
                            this.categoryList1 = c.value.split(';');
                            this.categoryNum = this.categoryList1.length;
                        }
                    }
                    if(v.type == c.tagType && c.label == v.labelParent && v.type == 7){ // 日期区间
                        c.childrens.forEach(e=>{
                            if(e.label == v.label[0]){
                                v['model' + i][0].start = e.value
                            }
                            if(e.label == v.label[1]){
                                v['model' + i][0].end = e.value
                            }
                        })
                    }
                })
            })

        },
        getTagNumber(str){
            let number=0
            switch(str){
                case 'INPUT':{
                    break
                }
                case 'TEXTAREA':{
                    number=1
                    break
                }
                case 'NUMBER':{
                    number=2
                    break
                }
                case 'SELECT':{
                    number=3
                    break
                }
                case 'RADIO':{
                    number=4
                    break
                }
                case 'CHEKBOX':{
                    number=5
                    break
                }
                case 'DATE':{
                    number=6
                    break
                }
                case 'DATEAREA':{
                    number=7
                    break
                }
                case 'IMAGE':{
                    number=8
                    break
                }
                case 'FILE':{
                    number=9
                    break
                }
                case 'TEXT':{
                    number=10
                    break
                }
                case 'COMPOUND':{
                    number=11
                    break
                }
                default:{
                    break
                }
            }
            return number
        },
        initFromData(){
            this.formData.map((v, i) => { 
                console.log(v,'vvv')
                v.tagType=this.getTagNumber(v.tagType);
                v.attributes=JSON.parse(v.attributes)
                if(v.tagType === 0 && v.label === 'Name') {
                    const val = ''; 
                    this.formModel.push({['model' + i]: val || '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                    return;
                }  
                if(v.tagType === 0 && v.label === 'Mobile') {
                    const val = this.user ? this.user.phoneText : ''; 
                    v.attributes.checkOptions.require=false;
                    this.formModel.push({['model' + i]: val || '', index : i, validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                    return
                } 
                if(v.tagType === 0 && v.label === 'E-mail') {
                    const val = this.user ? this.user.email : ''; 
                    this.formModel.push({['model' + i]: val || '', index : i, validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                    return
                } 
                if(v.tagType === 0 && v.label === 'Job title') {
                const val = this.user ? this.user.jobTitle : ''; 
                this.formModel.push({['model' + i]: val || '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                } 
                if(v.tagType === 0 && v.label === 'Company') {
                const val = this.user ? this.user.company : '';
                this.formModel.push({['model' + i]: val || '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                } 
                if(v.tagType === 1 && v.label === '个人简介') {
                const val = this.user ? this.user.introduction : ''; 
                this.formModel.push({['model' + i]: val || '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                } 
                if (v.tagType === 11 && v.label === 'Region') { 
                    let addr = ''
                    if (this.user.province && this.user.city && this.user.county) {
                        this.areavalue = [
                            this.user.province,
                            this.user.city,
                            this.user.county
                        ];
                        addr =
                            this.user.province +
                            "/" +
                            this.user.city +
                            "/" +
                            this.user.county;

                       
                        } else if (this.user.province && this.user.city) {
                        addr = this.user.province + "/" + this.user.city;
                        this.areavalue = [this.user.province, this.user.city];
                        } else {
                        addr = this.user.province;
                        this.areavalue = [this.user.province];
                    }
                this.formModel.push({['model' + i]: addr, index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});  
                return;
                }
                if (v.tagType === 11 && v.label === '展馆选择') { 
                this.formModel.push({['model' + i]: '', index : i, isShow:false, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});  
                return;
                }
                if (v.tagType === 3) {  // 下拉框
                v.columns  = [];
                v.attributes.options.map(c=>{
                    v.columns.push(c.value);
                })
                this.formModel.push({['model' + i]: '', index : i, isShow:false, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 4) {  // 单选框
                this.formModel.push({['model' + i]: '', index : i, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 5) {  // 多选框
                this.formModel.push({['model' + i]: [], index : i, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 6) {  // 日期框
                this.formModel.push({['model' + i]: '', index : i, isShow:false, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 7) {   // 日期区间
                    this.formModel.push({
                        ['model' + i]: [{start: '', end: ''}], 
                        index : i,
                        validate: false,
                        attributes: v.attributes,
                        isShow:false,
                        type: v.tagType, 
                        labelParent:v.label,
                        parentId:v.childrens[0].parentId,
                        label: [v.childrens[0].label, v.childrens[1].label], 
                        
                    }); 
                    return;
                }
                if (v.tagType === 10) {  // 文字说明
                  this.formModel.push({['model' + i]: [], index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                  return;
                }
                this.formModel.push({['model' + i]: '', index : i, validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
            }); 
            console.log(this.formModel,'this.formModel')
            // this.formItems = this.formData;
        },
        onCity(e){ //选择地区
          // this.form.area = e
          console.log(e, "选择国家");
          this.showArea = false;
          this.country.forEach(c=>{ // 选择国旗
            if(c.nameEn == e) {
              this.formModel[this.curIndex]['model' + this.curIndex]  = c.nameEn
              this.form.flagStyle=c.shortNameEn
            }
          })
            // console.log(e,'选择地区');
            // let areaList = [];
            // e.forEach(c => {
            //     areaList.push(c.name)
            // });
            // this.areavalue = areaList;
            // this.showArea = false;
            // // this.form.area = areaList.join("/");
            // this.formModel[this.curIndex]['model' + this.curIndex] = areaList.join("/");
            // console.log(this.formModel[this.curIndex]['model' + this.curIndex],'--')
        },
        regCareShow() { // 打开类别弹框
            this.$refs["regCare"].open();
        },
        closePop(checkList,vals) { // 选中类别并关闭弹框
            console.log(checkList,'选中的类别',vals);
            this.categoryNum = vals.length;
            this.form.category = checkList;
            this.categoryList1 = checkList.split(';');
            console.log(this.categoryList1,'this.categoryList1')
            console.log(this.form.category,'this.form.category')
        },
        async onSubmit(){  // 提交表单
            if(!this.validForm()) return; // 验证失败  
            // if (!this.checkbox) {
            //     this.$toast.fail('请确认同意服务条款');
            //     return;
            // }
            // if(!this.user.phone){ // 手机号没认证
            //     let checkRes =  await this.Checkphone();
            //     if(!checkRes) {
            //         return;
            //     }
            //     let MobBody = {
            //         memberId:this.user.id,
            //         phonenNumber:this.form.Phone,
            //     }
            //     this.putPhone(MobBody);
            // }
            const formFill = await this.transformSumbitData();
            let result = true; 
            // this.form.PhoneText=this.form.Phone;
            console.log(this.user,'user');
            if(!this.user||!this.user.inMember){
                this.userAddReg(formFill);
                return
            } else if(this.user.inMember.userRole == 'VISITOR') { // 没有注册
                result = await this.addVisit(this.form);
            } else { // 已注册
                result = await this.editUser(this.form);
            }
            if (!result) return;  // 已经提交注册表单了;
            this.submitCustomForm(formFill);
        },
        async userAddReg(form){ //没有登陆用户注册
            console.log(form,this.form,'form');
            // return 
            let body = {
                name: this.form.name,
                phoneText: this.form.PhoneText,
                password: this.form.Password,
                jobTitle: this.form.JobTitle,
                company: this.form.company,
                country: this.form.Province,
                category:this.form.category,
                email: this.form.email,
                exhibitionId: this.exhibitionId,
                flagStyle: this.form.flagStyle,
                originType: this.regOrigin ? this.regOrigin.originType : '',
                originId: this.regOrigin ? this.regOrigin.originId : '',
                originRemark: this.regOrigin ? this.regOrigin.originRemark : '',
                originLang: "en",
                formWrite:{
                    itemId: this.exhibitionId, 
                    userId:'',
                    formId:this.formId,
                    items: form
                }
            };
            let result =  await this.addReg(body);
            if(result.result){ // 注册成功
                this.$toast.success('success');
                this.$Myapollo.getUserInfo(this);
                this.LinkToRegFinsh();
                this.setRegOrigin(null); // 清除注册的来源，防止在别的展会注册时，来源有误
            } else{  // 注册失败
                this.$toast.fail(result.message);
            }
        },
        async addVisit(form){ // 注册
            let opt = {
                inMemberId: this.user.inMember.id,
                exhibitorId: this.exhibitionId,
                category: this.form.category,
                avatarUrl: this.user.avatarUrl,
                originType: this.regOrigin ? this.regOrigin.originType : '',
                originId: this.regOrigin ? this.regOrigin.originId : '',
                originRemark: this.regOrigin ? this.regOrigin.originRemark : '',
                ...form,
            }
            console.log(opt,'opt')
            let result =  await this.regUser(opt);
            return new Promise((resolve, reject) => {
                if(result.result){ // 注册成功
                    // this.$toast.success('注册成功');
                    // this.$Myapollo.getUserInfo(this);
                    // this.LinkToRegFinsh();
                    resolve(true);
                    this.setRegOrigin(null); // 清除注册的来源，防止在别的展会注册时，来源有误
                } else{  // 注册失败
                    this.$toast.fail(result.message);
                    resolve(false);
                }
            })
        },
        async editUser(form){ // 编辑用户信息
            let opt = {
                id: this.user.id,
                body:{...form}
            }
            let result =  await this.patchUser(opt);
            let opt2 = {
                id: this.user.inMember.id,
                body:{
                    category: this.form.category
                }
            }
            let result2 = await this.patchUserCategory(opt2);
            return new Promise((resolve, reject) => {
                if(result.result && result2.result){ // 注册成功
                    resolve(true);
                } else{  // 修改失败
                    if(!result.result){
                        this.$toast.fail(result.message);
                        resolve(false);
                    }
                    if(!result2.result){
                        this.$toast.fail(result2.message);
                        resolve(false);
                    }
                }
            })

        },
        async submitCustomForm(formFill){ // 提交自定义注册表单数据
            const reqBody = { 
                itemId: this.exhibitionId, 
                formId:this.formId, 
                userId: this.user.userId, 
                items: formFill 
            };   
            let result =  await this.addCustomForm(reqBody);
            if(result.result) {
                this.$toast.success('数据提交成功');
                if(this.user.inMember.userRole == 'VISITOR') { // 没有注册
                    this.LinkToRegFinsh();
                } else { // 已注册
                    this.$router.go(-1);
                }
            } else {
                this.$toast.fail(result.message);
            }
        },
        async transformSumbitData() { // 转换数据为提交的表单
            return new Promise((resolve, reject) => {
                const valArr = [];
                this.formModel.forEach((v, i) => {
                    if (v.type === 10) return;
                    let obj = {};
                    let objArr = []; 
                    if (v.type === 7) { // 日期区间
                        const dateRange = [v['model' + i][0].start, v['model' + i][0].end]; 
                        valArr.push({
                                label: v.labelParent, 
                                Value: '', 
                                tagType: v.type,
                                childrens:[
                                    {label:v.label[0],Value: v['model' + i][0].start},
                                    {label:v.label[1],Value: v['model' + i][0].end,}
                                ]
                            });
                        return;
                    }
                    if (v.type === 1 && v.label === '个人简介') { 
                        valArr.push({label: v.label, Value: v['model' + i], tagType: v.type});
                        return;
                    } 
                    if (v.type === 5) { 
                        valArr.push({label: v.label, Value: JSON.stringify(v['model' + i]), tagType: v.type});
                        return;
                    } 
                    if (v.type === 11 && v.label === 'Region') { 
                        valArr.push({label: 'Region', Value: v['model' + i], tagType: v.type}); 
                        return;
                    }   
                    if (v.type === 11 && v.label === 'Interest') { 
                        valArr.push({label: v.label, Value: this.form.category, tagType: v.type});
                        return;
                    } 
                    obj = {label: v.label, Value: v['model' + i], tagType: v.type}; 
                    valArr.push(obj);
                });  
                // valArr.map(v => {
                //     if(v.tagType === 5 && Array.isArray(v.Value)) { 
                //         v.Value = [...v.Value[0]]; 
                //     }
                // }); 
                this.fillDefaultFormValue(valArr);
                resolve(valArr);
            });
        },
        fillDefaultFormValue(Data) { // 填充观众注册默认提交数据
            if(!Data) return; 
            Data.forEach(c => { 
                switch (c.label) {
                case 'Name':
                    this.form.name = c.Value;
                    break;
                case 'Mobile':
                case 'PhoneText':
                    this.form.PhoneText = c.Value;
                    break;
                case 'Company':
                    this.form.company = c.Value;
                    break;
                case 'Job title':
                    this.form.JobTitle = c.Value;
                    break; 
                case 'Region':
                    this.form.Province = c.Value.split('/')[0];
                    this.form.City = c.Value.split('/')[1];
                    this.form.County = c.Value.split('/')[2];
                    break; 
                case 'Interest':
                    this.form.category = c.Value;
                    break; 
                case 'Password':
                    this.form.Password = c.Value;
                    break;
                case 'E-mail':
                    this.form.email = c.Value;
                    break;
                }
            }); 
            console.log(this.form,'注册的表单数据')
        },

        validForm() { // 根据类型验证表单 
            let valid = true;
            let errorTxt = 'Form validation failed'; 
            this.formModel.map((v, i) => { // 批量验证 表单选项
                if (!valid)return;
                switch (v.type) {
                    case 0: // 单行文本   
                    case 1: // 多行文字   
                        valid = this.setRegRule(v['model' + i],v.attributes.checkOptions);
                        console.log(valid,'valid',v.attributes)
                        if (!valid) {
                            errorTxt = `${v.label}Validation failed`;
                        } 
                        break;
                    case 3: // 下拉选择框
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                            errorTxt = `${v.label}Option is empty,` + errorTxt;
                        } 
                        break;
                    case 4: // 单选
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                        errorTxt = `${v.label}Option is empty,` + errorTxt;
                        } 
                        break;
                    case 5: // 多选
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                        errorTxt = `${v.label}Select at least one item`;
                        } 
                        break;
                }
            });
            if (!valid) {
                this.$toast.fail(errorTxt)
            } 
            return valid;
        },
        checkFormItem (v, control) { // 检查单个表单 必填等
            const checkOpt = v.checkOptions;
            let valid = true;  
            if (checkOpt && checkOpt.require && String(control) === '') { // 验证必填
                valid = false;
            }  
            return valid;
        },

        confirm(e,type){ // 下拉菜单的选项
          console.log(e,type,'下拉菜单的选项');
          if(type == 1) {
              this.formModel[this.curIndex]['model' + this.curIndex] = e;
              this.formModel[this.curIndex].isShow = false;
          } 
          if(type == 2) {
            let time = new Date(e);
            let date =this.timeFormat(time);
            console.log(date,'日期2');
            this.formModel[this.curIndex]['model' + this.curIndex] = date;
            this.formModel[this.curIndex].isShow = false;
          }
          if(type == 3) {
            let time = new Date(e);
            let date = this.timeFormat(time);
            console.log(date,'日期2');
            if(this.isStart){
                this.formModel[this.curIndex]['model' + this.curIndex][0].start = date;
                this.formModel[this.curIndex].isShow = false;
            } else {
                this.formModel[this.curIndex]['model' + this.curIndex][0].end = date;
                this.formModel[this.curIndex].isShow = false;
            }
          }
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + this.appendZero(month) + '-' + this.appendZero(day)
        },
        appendZero (obj) {
            return obj < 10 ? "0" + obj : obj 
        },
        confirmHall(e){ // 展馆选择
            console.log(e,'展馆选择');
            this.formModel[this.curIndex]['model' + this.curIndex] = e;
            this.formModel[this.curIndex].isShow = false;
        },
        setRegRule(val,rules) { // 根据验证选项返回验证规则
            const ruleArr = Object.keys(rules);
            if(!rules.require){
                return true;
            }
            let ruleStr = true;
            ruleArr.forEach(c => {
                if (c === "phone" && rules[c]) {
                ruleStr = /^1[3456789]\d{9}$/.test(val);
                }
                if (c === "email" && rules[c]) {
                ruleStr = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
                }
                if (c === "idCard" && rules[c]) { // 身份证
                ruleStr = /(^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$)/.test(val);
                }
                if (c === "other" && rules[c] !== "") {
                    let reg = rules[c].replace(/^(\s|\/)+|(\s|\/)+$/g, '');
                    let regExp = new RegExp(reg);
                    ruleStr = regExp.test(val);
                }
            });
            return ruleStr;
        },
        
        //手机号校验
        validatorPhone(val) {
            return /^1[3456789]\d{9}$/.test(val);
        },
        // 邮箱验证
        validatorEamil(val) {
            return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
        },
        // 获取手机号验证码
        async getCode(email){
          console.log(email,'email')
            if (!this.validatorEamil(email)) {
                this.$toast.fail('error Eamil')
                return;
            } else {
                this.newDownTime();
                let res = await this.sendEamilCode({
                  email: email
                });
                if (res.result) {
                  this.$toast.success("send success");
                  this.codeKey = res.data.key;
                } else {
                  this.$toast.fail('fail')
                }
            }
        },
        //验证手机号
        async Checkphone() {
            let res = await this.validateCode({
                key: this.codeKey,
                code: this.code
            });
            return new Promise((resolve, reject) => {
                if (res == true) {
                this.resetDown();
                resolve(true);
                } else {
                this.$toast.fail('手机号验证失败')
                this.resetDown();
                resolve(false);
                }
            })
        },


        resetDown(){ // 重置验证码
            clearInterval(this.newTimer);
            this.newCount = 0;
            this.newTimer = null;
            this.code = "";
        },

        //新手机号倒计时
        newDownTime() {
            const newTIME_COUNT = 60;
            if (!this.newTimer) {
                this.newCount = newTIME_COUNT;
                const newTimer = setInterval(() => {
                let count = this.newCount;
                if (count > 0 && count <= newTIME_COUNT) {
                    count--;
                    this.newCount = count;
                } else {
                    clearInterval(this.newTimer);
                    this.newTimer = null;
                }
                }, 1000);
                this.newTimer = newTimer;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
//   padding-bottom: .5rem;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin:.45rem 0;
  }
  .custom-form{
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    ::v-deep .reg_from{
      .intro_title{
        height: 0.77rem;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;
        font-size: 0.3rem;
        color: #333;
      }
      .van-cell{
        padding: 0 0.3rem;
        height: 0.98rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        &.intro_cell{
          height: 2rem;
        }
        &.cate_cell{
          .van-cell__title{
            flex: 0.4;
          }
          
          .van-cell__value{
            text-align: left;     
            p{
              font-size: 0.3rem;
              span{
                font-size: 0.3rem;
                color:#ff5c00 ;
              }
            }
          }
        }
        .van-field__label{
          color: #333;
        }
        .van-cell__value{
          .van-field__control{
             color:#666666;
          }
          span{
            font-size: .3rem;
          }
        }
      }
    }

    }
}
.cell-box{
    margin-bottom:10px;
}
.cell{
    // padding: 0 .3rem;
    &-title{
        font-size: .3rem;
        margin:10px .3rem;
        color: #333;
    }
    .yd-checkbox_wrap{
        border: solid 1px #e5e5e5;
        border-radius: 5px;
        background: #fff;
        margin-bottom: 10px;
    }
    .yd-checkbox-list{
        display: flex;
        min-height: .98rem;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid #e5e5e5;
        width: 100%;
        line-height: 1.2;
    }
    .yd-checkbox-list:last-child{
        border: none;
    }
    .van-radio__label{
        font-size: .3rem;
    }
}
.cell-1{
    padding: 0 .3rem;
    .cell-title{
        margin:10px 0;
    }
}
.tipInfo{
    margin: 10px .3rem ;
    font-size: .3rem;
    line-height: 1.5;
}
.require{
    position: relative;
}
.require::before {
    position: absolute;
    left: -8px;
    top: 6px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}
</style>